import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';
import {Award, Mail} from 'lucide-react';
import {getTeachers} from '../utils/api';

const Teachers = () => {
    const [teachers, setTeachers] = useState([]);

    useEffect(() => {
        const fetchTeachers = async () => {
            try {
                const data = await getTeachers();
                setTeachers(data);
            } catch (error) {
                console.error('Error fetching teachers:', error);
            }
        };
        fetchTeachers();
    }, []);

    return (
        <div className="min-h-screen pt-24" data-testid="teachers-page">
            <section className="relative py-20 overflow-hidden bg-gradient-to-br from-violet-900 via-purple-800 to-blue-900 text-white">
                <div className="container mx-auto px-4 md:px-8 text-center">
                    <motion.div initial={{opacity: 0, y: 30}} animate={{opacity: 1, y: 0}} transition={{duration: 0.8}}>
                        <h1 className="font-outfit font-bold text-5xl md:text-7xl mb-6 text-white">Our Faculty</h1>
                        <p className="font-dm-sans text-xl md:text-2xl max-w-3xl mx-auto text-white/95">Experienced educators dedicated to student success</p>
                    </motion.div>
                </div>
            </section>

            <section className="py-24 bg-white">
                <div className="container mx-auto px-4 md:px-8">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {teachers.map((teacher, index) => (
                            <motion.div key={teacher.id} className="bg-muted rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all" initial={{opacity: 0, y: 20}} whileInView={{opacity: 1, y: 0}} transition={{delay: index * 0.1}} data-testid={`teacher-card-${index}`}>
                                <div className="w-32 h-32 rounded-full mx-auto mb-6 bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center text-white text-4xl font-bold">
                                    {teacher.name.split(' ').map(n => n[0]).join('')}
                                </div>
                                <h3 className="font-outfit font-bold text-2xl text-center mb-2">{teacher.name}</h3>
                                <p className="text-center text-primary font-medium mb-4">{teacher.designation}</p>
                                <div className="space-y-2 text-sm text-slate-600">
                                    <div className="flex items-center gap-2">
                                        <Award className="w-4 h-4 text-primary" />
                                        <span>{teacher.qualification}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Mail className="w-4 h-4 text-primary" />
                                        <span>Experience: {teacher.experience}</span>
                                    </div>
                                </div>
                                <div className="mt-4 pt-4 border-t border-border">
                                    <p className="text-xs text-muted-foreground mb-2">Subjects:</p>
                                    <div className="flex flex-wrap gap-2">
                                        {teacher.subjects.map((subject, i) => (
                                            <span key={i} className="px-3 py-1 bg-white rounded-full text-xs font-medium">
                                                {subject}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Teachers;